






































































import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import * as types from '@/store/types';
import { MeModel } from '@/entities';

import { format, parse } from 'date-fns';
import {
    findTimeZone,
    getZonedTime,
    getUnixTime,
    convertDateToTime,
    getUTCOffset
} from 'timezone-support';

@Component({})
export default class PageHeader extends Vue {
    @Prop() public pageTitle: string;
    @Prop() public showTimeZone: boolean;

    public currentTime: string = '';
    public timerId: any = null;
    private timeZone: any;

    get username() {
        const me: MeModel = this.$store.getters[types.AUTH_GET_ME];
        if (!me) {
            return '';
        }
        return me.username;
    }

    public created() {
        this.timeZone = findTimeZone('America/New_York');
        this.tick();
    }

    public destroyed() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
    }

    public tick() {
        const t = getZonedTime(new Date(), this.timeZone);
        const nd = new Date(
            t.year,
            t.month - 1,
            t.day,
            t.hours,
            t.minutes,
            t.seconds
        );
        this.currentTime = format(nd, 'ddd, DD MMM YYYY HH:mm:ss') + ' EDT';
        this.timerId = setTimeout(this.tick, 1000);
    }
}
